<template>
  <div class="content_box">
    <div style="width: 100%;height: 10px"></div>
    <el-form :inline="true" size="mini" label-width="180px">
      <el-form-item label="交易时间">
        <el-date-picker
                v-model="searchForm.createTm"
                size="mini"
                type="datetimerange"
                range-separator="-"
                style="width: 100%"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model.trim="searchForm.orderId" placeholder="请输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="流水状态">
        <el-select v-model="searchForm.functionType" placeholder="请选择">
          <el-option v-for="item in functionTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <span class="no-label">
        <el-button size="mini" style="margin-left:50px" v-track="{ action: 'usualLine_query' }" type="danger" @click="onSearch">查询</el-button>
        <el-button size="mini" style="margin-left:20px" @click="onReset">重置</el-button>
      </span>
    </el-form>
<!--    //列表-->
    <el-row class="bannerBootom" style="padding:15px;">
      <el-table
              ref="table"
              element-loading-text="请稍后..."
              :data="pageData"
              :highlight-current-row="true"
              style="width: 100%"
      >
        <!--  <el-table-column label="序号" width="60"
           ><template slot-scope="scope">{{
             scope.$index + 1
           }}</template></el-table-column
         > -->
        <el-table-column
                v-for="(item, index) in tableColunm"
                :key="index"
                :label="item.label"
                :prop="item.prop"
                :width="item.width"
                :formatter="item.formatter"
        ></el-table-column>
        <el-table-column prop="orgName" label="流水主体">{{orgName}}</el-table-column>
      </el-table>

      <el-pagination
              :page-size="pageInitInfo.pageSize"
              :page-sizes="pageInitInfo.pageSizes"
              :current-page="pageInitInfo.pageNumber"
              :total="pageInitInfo.total"
              layout="sizes, prev, pager, next, jumper, ->, total, slot"
              @current-change="currentChange"
              @size-change="sizeChange"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      tableColunm:[
        {
          prop: 'createTm',
          label: '交易时间',
          width: 200,
            formatter: function(row, column) {
              if (row.createTm){
                return moment(new Date(row.createTm)).format("YYYY-MM-DD HH:mm:ss");
              }
              return '/';
          },
        },
        {
          prop: 'orderMoney',
          label: '金额',
          width: 200
        },
        {
          prop: 'orderId',
          label: '订单号',
          width: 200
        },
        {
          prop: 'functionType',
          label: '流水状态',
          width: 200,
        formatter: function(row, column) {
          if (row.functionType==1) {
            return '预付';
          }
          if (row.functionType==2) {
            return '预付退款';
          }
          if (row.functionType==4) {
            return '付款';
          }
          if (row.functionType==5) {
            return '确认后退款';
          }
          if (row.functionType==6) {
            return '扣款';
          }
          return '/';
    }
        },
        {
          prop: 'beforeAmount',
          label: '历史可用金额（元）',
          width: 200,
          formatter: function(row, column) {
            if (row.beforeAmount&&row.beforeAmount>0){
              return row.beforeAmount+"元";
            }
            return "0元";
          }
        },
        {
          prop: 'afterAmount',
          label: '可用金额（元）',
          width: 200,
          formatter: function(row, column) {
            if (row.afterAmount&&row.afterAmount>0){
              return row.afterAmount+"元";
            }
              return "0元";
          }
        }
      ]
      ,
      pageInitInfo: {
        pageSizes: [10, 20, 30, 40, 50, 100],
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },
       bankAccount:"",
       bankCard:"",
       bankName:"",
       phone:"" ,
      searchForm:{
        createTm:null,
        createTmStart:null,
        createTmEnd:null,
        orderId:null,
        functionType:null,
      },
      functionTypeList:[
              {label:"预付",value:'1'},
              {label:"预付退款",value:'2'},
              {label:"付款",value:'4'},
              {label:"确认后退款",value:'5'},
              {label:"扣款",value:'6'},
              ],
      orgName:null,
      pageData:[],
      localCache:null
    }
  },
  created(){
    this.initOrg();
    this.getPagaData();
  },
  mounted(){
  },
  methods:{
    ...mapActions([
      "getAllFlowMoneyDetail",
    ]),
    onReset(){
      this.searchForm.orderId=null
      this.searchForm.functionType=null
      this.searchForm.createTm=null
      this.searchForm.createTmStart=null
      this.searchForm.createTmEnd=null
    },
    getBankCardInfo(accountId){
    },
    currentChange(val) {
      // alert(val)
      this.pageInitInfo.pageNumber = val;
      this.getPagaData();
    },
    // 每页展示多少条数据改变事件
    sizeChange(val) {
      this.pageInitInfo.pageSize = val;
      this.pageInitInfo.pageNumber = 1;
      this.getPagaData();
    },
    onSearch(){
      this.pageInitInfo.pageNumber = 1;
      this.getPagaData()
    },
    getPagaData(){
      if (this.orgName==null||this.orgName==''){return;}
      if (this.searchForm.orderId==''){this.searchForm.orderId=null;}
      let dateStart=null;
      let dateEnd=null;
      if (this.searchForm.createTm&&this.searchForm.createTm.length>0){
        dateStart=moment(new Date(this.searchForm.createTm[0])).format("YYYY-MM-DD HH:mm:ss'")
        dateEnd=moment(new Date(this.searchForm.createTm[1])).format("YYYY-MM-DD HH:mm:ss'")
      }
      let param={
        "orgId":this.localCache.orgId,
        "pageSize":this.pageInitInfo.pageSize,
        "createTmStart":dateStart,
        "createTmEnd":dateEnd,
        "functionType":this.searchForm.functionType,
        "orderId":this.searchForm.orderId,
        "pageNum":this.pageInitInfo.pageNumber
      }
      this.getAllFlowMoneyDetail(param).then(res => {
        this.pageData=res.rows;
        this.pageInitInfo.total = res.totalCount;
      }).catch(e => {

      });
    },
    initOrg(){
      let item = window.sessionStorage.getItem('MoneyFlowDetailData');
      if (item){
        let parse = JSON.parse(item);
        this.orgName=parse.orgName
        this.localCache=parse
      }
      window.sessionStorage.removeItem('MoneyFlowDetailData');
    }
  }
};
</script>

<style lang="less" scoped>

</style>